// extracted by mini-css-extract-plugin
export default {"header":"ReviewField_header__Q1c7i","inputText":"ReviewField_inputText__lo6gk"};